export const PlusIcon = () => (
  <svg
    className="w-4 h-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 4v16m8-8H4"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    className="w-4 h-4 text-gray-400"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export const WifiIcon = ({ status }) => {
  const colorMap = {
    live: "#22c55e",
    online: "#22c55e",
    interval: "#3b82f6",
    warning: "#f97316",
    offline: "#9ca3af",
  };

  const c = colorMap[status] || "#9ca3af";

  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M1.41 8.59L3 10.18A13.96 13.96 0 0 1 12 7c3.25 0 6.23 1.1 8.6 2.94L22.19 8.35C19.34 6.12 15.82 4.75 12 4.75S4.66 6.12 1.81 8.35L1.41 8.59z"
        fill={c}
      />
      <path
        d="M5.59 12.41A8.97 8.97 0 0 1 12 10a8.97 8.97 0 0 1 6.41 2.41l1.59-1.59A11.02 11.02 0 0 0 12 8a11.02 11.02 0 0 0-7.94 3.41l1.53 1z"
        fill={c}
      />
      <circle cx="12" cy="18" r="2" fill={c} />
    </svg>
  );
};
export const WarningIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="#f97316">
    <path d="M12 2L1 21h22L12 2zm0 3.5L21 19H3L12 5.5zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z" />
  </svg>
);
